// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { ReactElement, memo } from 'react';

import './HTMLPreview.scss';

interface HTMLPreviewProps {
    className?: string | string[];
    src: string;
}

export const HTMLPreview = memo(
    ({ className, src }: HTMLPreviewProps): ReactElement => (
        <iframe
            loading="lazy"
            sandbox=""
            referrerPolicy="no-referrer"
            src={src}
            className={classList('HTMLPreview', className)}
            title="html attachment preview"
        />
    ),
);
